import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data?.length) return data

    // notification is for the inbox
    return data[0].tags?.includes('inbox') ? null : data[0]
  }, [data])
}
